import React, { useEffect, useState } from 'react';
import { KFLButton, KFLDialog } from '@kamstrup/kamstrup-frontend-library';
import DialogHeader from '../../shared/dialog/dialogHeader';
import Translate from '../../shared/localization/localize';
import DialogSection from '../../shared/dialog/dialogSection';
import {
  TransferDialogs,
  TransferStatus,
} from '../../../modules/dialogs/transfer';
import TransferSummary from './transferSummary';
import Scrim from '../../shared/scrim';
import * as m from '../../../modules/dialogs/transfer/messages';
import useTxRequest from '../../../modules/dialogs/transfer/useTxRequest';
import DialogFooter from '../../shared/dialog/dialogFooter';
import ReCaptchaForm from '../../shared/recaptcha';
import useLocale from '../../../hooks/useLocale';
import SandwichBox from '../../shared/sandwichBox';

const TxDialogReqCheck: React.FC = () => {
  const { translate } = useLocale();
  const {
    tx,
    validate,
    validateStatus,
    changeScreen,
    closePanel,
    setStatus,
  } = useTxRequest();
  const [recaptchaToken, setRecaptchaToken] = useState('');

  useEffect(() => validate(), []);

  const showRecaptcha =
    (tx.status === TransferStatus.VALIDATED) && !validateStatus.isFetching;

  const content = (
    <>
      <DialogSection isMain scrollable>
        <Scrim
          fullHeight
          isActive={validateStatus.isFetching}
          label={m.msgValidating}
          iconSize={16}
        >
          <SandwichBox
            bottom_bun={
              <SandwichBox>
                {!validateStatus.isFetching && validateStatus.errorMsg && (
                  <p className="error">{translate(validateStatus.errorMsg)}</p>
                )}
                <div className="tx_req_notarobot_box">
                  <ReCaptchaForm
                    onTokenChanged={setRecaptchaToken}
                    hide={!showRecaptcha}
                  />
                </div>
              </SandwichBox>
            }
          >
            <TransferSummary transfer={tx}></TransferSummary>
          </SandwichBox>
        </Scrim>
      </DialogSection>
    </>
  );

  const onRequestNow = () => {
    setStatus(TransferStatus.CONFIRMED);
    changeScreen(TransferDialogs.REQUEST_CONFIRM);
  };
  const isReqNowBtnReady =
    tx.status === TransferStatus.VALIDATED && recaptchaToken;
  const requestNowBtn = (
    <KFLButton
      id="dg-transfer-bt-next"
      key="dg-transfer-bt-next"
      onClick={onRequestNow}
      disabled={!isReqNowBtnReady}
    >
      {translate(m.msgRequestNowBtn)}
    </KFLButton>
  );

  return (
    <KFLDialog
      header={
        <DialogHeader
          title={<Translate message={m.msgHeaderReq} />}
          fnCloseDialog={closePanel}
          fnBackDialog={() => changeScreen(TransferDialogs.REQUEST)}
        />
      }
      sections={[content]}
      footer={
        <DialogFooter
          leftContent={''}
          buttons={[requestNowBtn]}
          hideCancelBtn
          fnCloseDialog={closePanel}
        />
      }
    />
  );
};

export default TxDialogReqCheck;
